import { HTMLAttributes } from "react";
import classNames from "classnames";
import st from "./Footer.module.scss";

interface IFooterProps extends HTMLAttributes<HTMLDivElement> {
	isWidget?: boolean;
	version?: string 
};

const Footer: React.FC<IFooterProps> = ( { version, className, ...otherProps } ) => (
    <footer className={classNames(st.footer, className )} {...otherProps}>
		<div className={st.footer__copy}>

			<span>Создано на базе:</span>
			
			<div className={st.footer__logo}>
				<span>Re:</span>
				<span className="logo-part">Doc</span>
			</div>
			
			<div className={st.delimiter} />

			<span>
				Единое деловое пространство
			</span>	
		</div>
		{
			!!version && <span className={st.footer__version}>{version}</span>
		}
	</footer>
);

export default Footer;
